// ***** Json for Asset Type and image *****
export const AssetType = {
    1: {
        imgpath: "/static/images/icons/asset/Datum.svg",
        responseValue: "3",
        Title: "RFD",
        Title1: "",
        assetType: "1"
    },
    2: {
        imgpath: "/static/images/icons/farming.svg",
        responseValue: "3",
        Title: "Gated",
        Title1: "Community",
        assetType: "2"
    },
    3: {
        imgpath: "/static/images/icons/iconsBarrier.svg",
        responseValue: "3",
        Title: "Barrel",
        Title1: "",
        assetType: "3"
    },
    4: {
        imgpath: "/static/images/icons/iconsBarrier.svg",
        responseValue: "3",
        Title: "Others",
        Title1: "",
        assetType: "4"
    },
    5: {
        imgpath: "/static/images/icons/DG.svg",
        responseValue: "999",
        Title: "DG set",
        Title1: "(Stationary)",
        assetType: "5"
    },
    6: {
        imgpath: "/static/images/icons/Industrial.svg",
        responseValue: "999",
        Title: "INDUSTRIAL",
        Title1: "(Stationary)",
        assetType: "6"
    },
    7: {
        imgpath: "/static/images/icons/Ifra_machine.svg",
        responseValue: "999",
        Title: "Infra.",
        Title1: "Machine",
        assetType: "7"
    },
    8: {
        imgpath: "/static/images/icons/Vector.svg",
        responseValue: "9999",
        Title: "Heavy",
        Title1: "Vehicle",
        assetType: "8"
    },
    9: {
        imgpath: "/static/images/icons/iconsBarrier.svg",
        responseValue: "9999",
        Title: "Others",
        Title1: "",
        assetType: "9"
    },
    10: {
        imgpath: "/static/images/icons/asset/Datum.svg",
        responseValue: "9",
        Title: "Infra.Eqe ",
        Title1: "(Stationary)",
        assetType: "7"
    },
    11: {
        imgpath: "/static/images/icons/infra.svg",
        responseValue: "9",
        Title: "Infra.Eqe ",
        Title1: "(Stationary)",
        assetType: "7"
    },
    12: {
        imgpath: "/static/images/icons/farming.svg",
        responseValue: "1",
        Title: "Farming",
        Title1: "(Stationary)",
        assetType: "12"
    },
    13: {
        imgpath: "/static/images/icons/Tank.svg",
        responseValue: "1",
        Title: "Tank",
        Title1: "",
        assetType: "13"
    },
    20: {
        imgpath: "/static/images/icons/RPSicon.svg",
        responseValue: "3",
        Title: "Datum",
        Title1: "",
        assetType: "1"
    },
    14: {
        imgpath: "/static/images/icons/asset/Datum.svg",
        responseValue: "5",
        Title: "Flowmeter",
        Title1: "",
        assetType: "14"
    },
};